import { myOwnFP_chart_palette2 } from "../../Components/Charts";
import { AgCharts } from "ag-charts-community";
import { formatNumber } from "../../App/GridFormatters";
import { myOwnFPColor } from "../../App/GridRenderers";
import { FooterHeight, HeaderHeight, marginX, marginY, pdfGridFontWidth } from "./Generate";
import { isArray } from "lodash";
import { Arrayify } from "../../Functions/utils";
import { UpdateAxes } from "../../App/Chart";


const shrinkFactor = 2

const pdfChartFontSize = 7
const gridColumnPadding = 1 // the default is 8 (left(8) + right(8) so 1+1 is better )

const PHeight = (size) => {
    let h = 14
    switch (size) {
        case 0:
            h = 11
            break;
        case 1:
            h = 14
            break;
        case 2:
            h = 17
            break;
        default:
            break;

    }
    return (72 * h) - (2 * marginY) - (HeaderHeight + FooterHeight)
}

const LsWidth = (size) => {
    let h = 14
    switch (size) {
        case 0:
            h = 11
            break;
        case 1:
            h = 14
            break;
        case 2:
            h = 17
            break;
        default:
            break;

    }
    return (72 * h) - (2 * marginX)
}

// const PWidth = (size) => {
//     let w = 8.5
//     switch (size) {
//         case 0:
//             w = 8.5
//             break;
//         case 1:
//             w = 8.5
//             break;
//         case 2:
//             w = 11
//             break;
//         default:
//             break;

//     }
//     return (72 * w) - (2 * marginX)
// }

const LsHeight = (size) => {
    let w = 8.5
    switch (size) {
        case 0:
            w = 8.5
            break;
        case 1:
            w = 8.5
            break;
        case 2:
            w = 11
            break;
        default:
            break;

    }
    return (72 * w) - (2 * marginY) - (HeaderHeight + FooterHeight)
}
const DefOptions = (pageSize) => {
    const defOptions = {
        theme: {
            palette: myOwnFP_chart_palette2,
            overrides: {
                common: {
                    title: {
                        fontSize: (pdfChartFontSize + 2) * shrinkFactor,
                        spacing: 2,
                    },
                    subtitle: {
                        fontSize: (pdfChartFontSize * shrinkFactor),
                        spacing: 4,
                    },
                    axes: {
                        number: {
                            label: {
                                fontSize: ((pdfChartFontSize - 1) * shrinkFactor),
                            }
                        },
                        category: {
                            label: {
                                fontSize: ((pdfChartFontSize - 1) * shrinkFactor),
                            },
                            interval: {
                                step: 5,
                            }
                        }
                    }
                },
                line: {
                    series: {
                        marker: {
                            size: 3,
                        },
                        strokeWidth: 1,
                    },
                },
            },
        },
        series: {
            marker: {
                size: (pdfChartFontSize * shrinkFactor),
            },
        },
        padding: {
            left: 0,
            right: 0,
            top: 2,
            bottom: 2,
        },
        axes: [
            {
                type: 'number',
                position: 'left',
                label: {
                    fontSize: ((pdfChartFontSize - 1) * shrinkFactor),
                    format: '#{->,.2s}',
                    // formatter: (params) =>
                    //     params.formatter(params.value).replace('k', 'K').replace('y', '')
                },
            },
            {
                type: 'category',
                position: 'bottom',
                label: {
                    fontSize: ((pdfChartFontSize - 1) * shrinkFactor),
                },
                interval: {
                    step: 2,
                }
            },
        ],
        height: LsHeight(pageSize),
        width: LsWidth(pageSize),
        legend: {
            position: "right",
            spacing: 2,
            item: {
                paddingX: 1,
                paddingY: 4,
                label: {
                    fontSize: (pdfChartFontSize * shrinkFactor),

                    //fontStyle: 'italic',
                    //fontWeight: 'bold',
                    //fontFamily: 'Papyrus',
                    //color: 'red',
                    //maxLength: 25,
                },
                marker: {
                    size: (pdfChartFontSize * shrinkFactor),
                    padding: 1,
                }
            },
        },
    }
    return defOptions
}

const Client = (page, data) => {
    let cl = data.Clients[0]

    if (data.Clients.length > 1) {
        if (page.Who !== "Personal") {
            if (data.Clients.length > 1) {
                if (page.Who === "Spousal") {
                    cl = data.Clients[1]
                } else {
                    cl = data.Clients[2]
                }
            } else {
                return []
            }
        }
    }
    //console.log(cl)

    let ds = ""

    if (data.DataSets !== undefined) {
        //console.log(page.Currency)
        if (page.Currency === "Real $") {
            ds = data.DataSets[0]
        } else {
            if (data.DataSets.length > 1) {
                if (page.Currency === "Report Start $") {
                    ds = data.DataSets[1]
                } else if (data.DataSets.length > 2) {
                    if (page.Currency === "Calc Start $") {
                        ds = data.DataSets[2]
                    } else {
                        //console.log(ds)

                        return []
                    }
                } else {
                    //console.log(ds)

                    return []
                }
            } else {
                //console.log(ds)

                return []
            }
        }
    } else {
        //console.log(ds)

        return []
    }
    //console.log(ds)

    return [cl, ds]
}

const agCreateGetImage = async (options, width, height) => {
    let chart = AgCharts.create(options);
    let imageBase64 = await chart.getImageDataURL({ width: width * shrinkFactor, height: height * shrinkFactor })
    return imageBase64
}
// const AddPage = (orientation) => {

//     return {
//         pageBreak: "before",
//         pageOrientation: orientation,
//         text: "",
//     }
// }


export const pdfChart3 = async (clientJson, page, data, avail, pageSize) => {

    let content = []
    let twoClients = data.Clients.length > 1

    let cl = twoClients ? "Joint" : data.Clients[0]

    const lsWidth = LsWidth(pageSize)
    const lsHeight = LsHeight(pageSize)

    for (const cur of avail.Currency) {
        if (!page.Currency.includes(cur)) {
            continue
        }
        let pg = structuredClone(page)
        pg.Currency = cur

        let clds = Client(pg, data)

        if (clds.length === 0) {
            continue
        }
        let ds = clds[1]
        // console.log(cl)
        // console.log(ds)

        let options = {
            ...DefOptions(pageSize),
            data: data.ClientData[cl][ds].Data,
            title: data.ClientData[cl][ds].Title,
            subtitle: { "text": cl + " : " + ds },
            series: data.ClientData[cl][ds].Series,
            axes: UpdateAxes(data.ClientData[cl][ds].Axes),
        }

        let imageBase64 = await agCreateGetImage(options, lsWidth, twoClients ? lsHeight / 2 : lsHeight)


        content.push({
            pageBreak: "before",
            pageOrientation: 'landscape',
            text: "",
        })

        content.push({
            image: imageBase64,
            width: lsWidth,
            height: twoClients ? lsHeight / 2 : lsHeight
        })

        if (twoClients) {
            cl = data.Clients[0]
            options = {
                ...options,
                padding: {
                    top: 10,
                },
                data: data.ClientData[cl][ds].Data,
                title: { text: "" },
                subtitle: { "text": cl + " : " + ds },
                series: data.ClientData[cl][ds].Series,
                axes: UpdateAxes(data.ClientData[cl][ds].Axes),
            }
            let imageBase64_0 = await agCreateGetImage(options, (lsWidth / 2), lsHeight / 2)


            cl = data.Clients[1]
            options = {
                ...options,
                data: data.ClientData[cl][ds].Data,
                title: { text: "" },
                subtitle: { "text": cl + " : " + ds },
                series: data.ClientData[cl][ds].Series,
                axes: UpdateAxes(data.ClientData[cl][ds].Axes),
            }
            let imageBase64_1 = await agCreateGetImage(options, (lsWidth / 2), lsHeight / 2)


            content.push({
                columnGap: 2,
                columns: [{
                    image: imageBase64_0,
                    align: "left",
                    width: (lsWidth / 2),
                    height: lsHeight / 2,

                },
                {
                    image: imageBase64_1,
                    align: "right",
                    width: (lsWidth / 2),
                    height: lsHeight / 2,
                },
                ],
            })
            content.push(AddComment(data.Info.Description))
        }
    }
    // console.log(content)
    return content
}

export const pdfChartCurrency = async (clientJson, page, data, avail, pageSize) => {

    let content = []
    let twoCurrencies = data.DataSets.length > 1

    const lsWidth = LsWidth(pageSize)
    const lsHeight = LsHeight(pageSize)
    // console.log(page)
    // console.log(data)
    for (const client of avail.Clients) {
        if (data.Clients.length === 1) {
            if (client !== 'Personal') {
                continue
            }
        } else {
            if (!page.Who.includes(client)) {
                continue
            }
        }
        let pg = structuredClone(page)
        pg.Who = client
        pg.Currency = "Real $"

        let clds = Client(pg, data)

        if (clds.length === 0) {
            continue
        }
        let cl = clds[0]
        let ds = clds[1]
        // console.log(cl)
        // console.log(ds)

        let options = {
            ...DefOptions(pageSize),
            data: data.ClientData[cl][ds].Data,
            title: data.ClientData[cl][ds].Title,
            subtitle: { "text": cl + " : " + ds },
            series: data.ClientData[cl][ds].Series,
            axes: UpdateAxes(data.ClientData[cl][ds].Axes),
        }

        let imageBase64 = await agCreateGetImage(options, lsWidth, twoCurrencies ? lsHeight / 2 : lsHeight)

        content.push({
            pageBreak: "before",
            pageOrientation: 'landscape',
            text: "",
        })

        content.push({
            image: imageBase64,
            width: lsWidth,
            height: twoCurrencies ? lsHeight / 2 : lsHeight
        })


        let chartCount = data.DataSets.length - 1
        let columns = {
            columnGap: 2,
            columns: []
        }
        for (const cur of avail.Currency) {
            if (cur === "Real $") { // already done
                continue
            }
            pg.Currency = cur
            let clds = Client(pg, data)

            if (clds.length === 0) {
                continue
            }
            let ds = clds[1]

            options = {
                ...options,
                padding: {
                    top: 10,
                },
                data: data.ClientData[cl][ds].Data,
                title: { text: "" },
                subtitle: { "text": cl + " : " + ds },
                series: data.ClientData[cl][ds].Series,
                axes: UpdateAxes(data.ClientData[cl][ds].Axes),
            }
            let imageBase64_0 = await agCreateGetImage(options, lsWidth / chartCount, lsHeight / 2)

            columns.columns.push({
                columns: [{
                    image: imageBase64_0,
                    width: lsWidth / chartCount,
                    height: lsHeight / 2,
                }],
            })
        }
        content.push(AddComment(data.Info.Description))

        //console.log(columns)
        if (columns.columns.length > 0) {
            content.push(columns)
        }
    }
    //console.log(content)
    return content
}






export const pdfChart = async (clientJson, page, data, avail, pageSize) => {

    let content = []
    //console.log(page)

    const lsWidth = LsWidth(pageSize)
    const lsHeight = LsHeight(pageSize)

    for (const cur of avail.Currency) {
        if (!page.Currency.includes(cur)) {
            continue
        }
        let pg = structuredClone(page)
        pg.Currency = cur

        for (const client of avail.Clients) {
            if (data.Clients.length === 1) {
                if (client !== 'Personal') {
                    continue
                }
            } else {
                if (!page.Who.includes(client)) {
                    continue
                }
            }
            pg.Who = client

            //console.log(pg)
            let clds = Client(pg, data)

            if (clds.length === 0) {
                continue
            }
            let cl = clds[0]
            let ds = clds[1]

            //console.log(data)
            //console.log(cl)
            //console.log(ds)

            let options = {
                ...DefOptions(pageSize),
                data: data.ClientData[cl][ds].Data,
                title: data.ClientData[cl][ds].Title,
                subtitle: { "text": cl + " : " + ds },
                series: data.ClientData[cl][ds].Series,
                axes: UpdateAxes(data.ClientData[cl][ds].Axes),
            }

            let imageBase64 = await agCreateGetImage(options, lsWidth, lsHeight)

            content.push({
                pageBreak: "before",
                pageOrientation: 'landscape',
                text: "",
            })
            content.push({
                image: imageBase64,
                width: lsWidth,
                height: lsHeight,
            })
            content.push(AddComment(data.Info.Description))
            // console.log(content)
        }
    }


    return content
}



// Row colors
const HEADER_ROW_COLOR = myOwnFPColor
const EVEN_ROW_COLOR = '#fcfcfc';
const ODD_ROW_COLOR = '#fff';

const PDF_INNER_BORDER_COLOR = '#dde2eb';
const PDF_OUTER_BORDER_COLOR = '#babfc7';

const createLayout = (numberOfHeaderRows) => ({
    fillColor: (i) => {
        if (i < numberOfHeaderRows) {
            return HEADER_ROW_COLOR;
        }
        return i % 2 === 0 ? EVEN_ROW_COLOR : ODD_ROW_COLOR;
    },
    //vLineHeight not used here.
    vLineWidth: (i, node) =>
        i === 0 || i === node.table.widths.length ? 1 : 0,
    hLineColor: (rowIndex, node) =>
        rowIndex === 0 || rowIndex === node.table.body.length
            ? PDF_OUTER_BORDER_COLOR
            : PDF_INNER_BORDER_COLOR,
    vLineColor: (i, node) =>
        i === 0 || i === node.table.widths.length
            ? PDF_OUTER_BORDER_COLOR
            : PDF_INNER_BORDER_COLOR,

    // padding on each cell
    paddingLeft: function (i) {
        return i === 0 ? gridColumnPadding : gridColumnPadding;
    },

    paddingRight: function (i, node) {
        return (i === node.table.widths.length - 1) ? gridColumnPadding : gridColumnPadding;
    },

});

const treeName = (parentTree, name) => {
    let tree = Arrayify(parentTree).join(":")
    if (parentTree.length === 2) {
        if (parentTree[0] === parentTree[1]) {
            tree = parentTree[0] + ":"  // this will end up with Cat::Acct
        }
    }

    tree += ":" + name
    return tree
}
const treeNameWC = (parentTree, accountType) => {

    let treeWC = parentTree[0] + ":"
    if (parentTree[0] !== parentTree[1]) {
        treeWC += parentTree[1]
    }
    treeWC += ":" + accountType + " <-All->"
    return treeWC

}


const isAddColumn = (parentTree, name, addColumns, accountType) => {

    const tree = treeName(parentTree, name)
    let added = false
    // console.log(tree)
    // console.log(addColumns)
    if (tree in addColumns) {
        added = addColumns[tree] === "on" ? true : false
        if (added) {
            console.log("Added: " + tree)
        }
    }
    if (!added && parentTree.length === 2) {
        let treeWC = treeNameWC(parentTree, accountType)
        // console.log(treeWC)
        // console.log(addColumns)

        if (treeWC in addColumns) {
            added = addColumns[treeWC] === "on" ? true : false
            if (added) {
                console.log("Added WC: " + tree)
            }
        }
    }
    if (!added && parentTree.length === 2) {

        let treeWC = parentTree[0] + ":"
        if (parentTree[0] !== parentTree[1]) {
            treeWC += parentTree[1]
        }
        treeWC += ":<-All->"
        //console.log(treeWC)

        let addedA = []
        Object.entries(addColumns).forEach(([c, v]) => {
            if (v === "on") {
                // console.log(c)
                let sc = c.startsWith(treeWC) ? c.substring(treeWC.length) : ""
                if (sc !== "") {
                    // console.log(sc)
                    const scc = sc.split("/")
                    if (scc.length > 0) {
                        // console.log(scc)
                        addedA.push(sc)
                    }
                }
            }
            addedA.push("")
        })
        //console.log(addedA)
        added = addedA.reduce((a, s) => {
            if (a) {
                return a
            }
            if (s !== "") {
                //console.log(s)
                const scc = s.split("/")
                if (scc.length > 0) {
                    return scc.reduce((v, nv) => {
                        if (v) {
                            return v
                        }
                        return name.endsWith(nv)
                    }, false)
                }
            }
            return a
        }, false)
        if (added) {
            console.log("Added WC: " + tree)
        }
    }
    return added
}

const isRemovedColumn = (parentTree, name, removedColumns, accountType) => {
    const tree = treeName(parentTree, name)
    // console.log(tree)
    // console.log(removedColumns)

    let removed = false
    if (tree in removedColumns) {
        removed = removedColumns[tree] === "off" ? true : false
        if (removed) {
            console.log("Removed: " + tree)
        }
    }
    if (!removed && parentTree.length === 2) {
        let treeWC = treeNameWC(parentTree, accountType)
        // console.log(treeWC)
        // console.log(removedColumns)

        if (treeWC in removedColumns) {
            removed = removedColumns[treeWC] === "off" ? true : false
            if (removed) {
                console.log("Removed WC: " + tree)
            }
        }
    }

    return removed
}




const getVisibleColumns = (headers, open, parentTree, addColumns, removedColumns) => {
    // console.log(addColumns)
    // console.log(removedColumns)
    let columns = []
    for (let i = 0; i < headers.length; i++) {
        let pTree = parentTree.slice()

        let h = headers[i]
        if (h.children && h.children.length > 0) {
            pTree.push(h.headerName)
            let children = getVisibleColumns(h.children, h.openByDefault, pTree, addColumns, removedColumns)
            if (children.length !== 0) {
                //console.log(children)
                h.children = children
                columns.push(h)
            }
        } else {
            const acctType = (h.context !== undefined) ? h.context.AccountType : ""

            if (!isRemovedColumn(pTree, h.headerName, removedColumns, acctType)) {
                if (h.columnGroupShow === undefined ||
                    (open && h?.columnGroupShow === "open") ||
                    isAddColumn(pTree, h.headerName, addColumns, acctType)) {
                    columns.push(h)
                    //console.log(h)
                }
            }
        }
    }
    //console.log(columns)
    return columns
}


const getColumns = (headers) => {
    let columns = []
    for (let i = 0; i < headers.length; i++) {
        let h = headers[i]
        if (h.children) {
            let children = getColumns(h.children)
            if (children.length !== 0) {
                columns.push(...children)
            }
        } else {
            if (h.colId !== undefined && h.colId !== null && h.colId !== "") {
                // console.log(h.colId)
                columns.push(h)
            } else if (h.field !== undefined && h.field !== null && h.field !== "") {
                // console.log(h.field)
                columns.push(h)
            }
        }
    }
    return columns
}



const depthChildren = (headers, curDepth) => {
    let depth = curDepth + 1
    for (let i = 0; i < headers.length; i++) {
        headers[i].depth = curDepth
        let h = headers[i]
        if (h.children && h.children.length > 0) {
            let newDepth = depthChildren(h.children, curDepth + 1)
            if (newDepth > depth) {
                depth = newDepth
            }
        }
    }
    return depth
}

const positionChildren = (headers, position, pinned) => {
    for (let i = 0; i < headers.length; i++) {
        let h = headers[i]
        headers[i].position = position
        if (h.children && h.children.length > 0) {
            position = positionChildren(h.children, position, pinned)
        }
        else if (h.colId !== undefined && h.colId !== null) {
            position += 1
        } else if (h.field !== undefined && h.field !== null) {
            position += 1
        }
    }
    return position
}


const fillChildren = (headers, columns) => {
    let keys = 0
    for (let i = 0; i < headers.length; i++) {
        let h = headers[i]
        columns[h.depth][h.position] = structuredClone({
            text: h.headerName,
            style: "header",
            margin: [0, 2, 0, 0],
        })
        if (h.children && h.children.length > 0) {
            keys += fillChildren(h.children, columns)
        } else {
            if (h.pinned === "left") {
                keys++
            }
        }
    }
    return keys
}


const getHeaderToExport = (headers) => {
    // console.log(headers)


    let depth = depthChildren(headers, 0)
    let position = positionChildren(headers, 0)
    // console.log("depth = " + depth)
    // console.log("position = " + position)
    // console.log(headers)

    let columns = Array(depth).fill().map(() => Array(position).fill({}))

    let keys = fillChildren(headers, columns)


    return [columns, keys]
}


const getRowsToExport = (columns, headers, dataOrig, topRow, aggregate) => {
    //console.log(data)
    if (dataOrig === null || !isArray(dataOrig)) {
        return []
    }

    //console.log(columns)
    // console.log(headers)
    // console.log(data)
    let rowCount = dataOrig.length
    if (aggregate && topRow !== null) {
        rowCount += 1
    }
    let rows = Array(rowCount).fill().map(() => Array(headers[0].length).fill(""))
    //console.log(rows)

    dataOrig.sort((a, b) => ((a.year !== undefined ? ((a.year > b.year) ? 1 : -1) : ((a.Year > b.Year) ? 1 : -1))))
    let data = dataOrig
    if (aggregate && topRow !== null) {
        // add the topRow to the data
        // console.log(topRow[0])
        data = [topRow[0], ...dataOrig]
        // console.log(data)
    }
    //console.log(data)
    for (let i = 0; i < rowCount; i++) {
        let r = data[i]

        columns.map((c) => {

            let v = {}
            if (c.colId !== undefined && c.colId !== null) {
                v = r[c.colId];
            } else if (c.field !== undefined && c.colId !== null) {
                v = r[c.field];
            } else {
                v = undefined
            }

            let entry = ""
            let style = "gridValue"
            if (v !== undefined && v !== null) {
                //console.log(c)
                //console.log(v)
                if (c.type !== undefined) {

                    if (c.type.includes("money") || c.type.includes("money_cashflow")) {
                        if (typeof v === "number") {
                        } else if (typeof v === "string") {
                            v = Number(v.split(";")[0])
                        }
                        entry = " $" + formatNumber(v)
                        style = "gridMoney"
                    }
                    else if (c.type.includes("percent")) {
                        if (typeof v === "number") {

                        } else {
                            v = Number(v.split(";")[0])
                        }
                        entry = " " + v.toFixed(2) + "%"
                        style = "gridPercent"
                    }
                    else if (c.type.includes("year") || c.type.includes("age")) {
                        entry = v
                        style = "gridValue"
                        if (typeof v === 'string') {
                            let split = v.split(";")
                            entry = " " + split[0] + " "
                            //console.log(split)
                            if (split[1] !== undefined && split[1] === "Started") {
                                style = "gridStart"
                            }
                        }
                    } else {
                        // console.log("unknown type")
                    }
                }
                entry = {
                    text: entry,
                    style: style,
                }
            }
            //console.log(c)
            //console.log(c.position)
            //console.log(entry)
            rows[i][c.position] = structuredClone(entry)
            return ""
        })

    }
    // console.log(rows)
    return rows
};

const minWidth = 5

const getRowWidths = (rows) => {
    let widths = []
    let widthsPct = []

    if (rows.length > 0) {
        const numCols = rows[0].length
        widths = Array(rows[0].length).fill(minWidth)
        for (let c = 0; c < numCols; c++) {
            for (let r = 0; r < rows.length; r++) {
                //console.log(r)
                if (rows[r][c].text !== undefined) {
                    let l = String(rows[r][c].text).length
                    // console.log("Row " + r + ", Col " + c + " text is " + rows[r][c].text + "   len is " + l)
                    if (l > widths[c]) {
                        widths[c] = l
                    }
                }
            }
        }
    }

    let totalWidth = 0
    if (widths.length > 0) {
        totalWidth = widths.reduce((totalWidth, v) => totalWidth + v)
        //console.log(totalWidth)
        if (totalWidth !== 0) {
            widthsPct = widths.map((cw) => (cw * 100 / totalWidth) + "%")
        }
        // console.log(widths)
    }
    return [widths, widthsPct]
}

const splitColumns = (rows, headers, widths, pageSize, tblKeys) => {
    let tbls = []

    let lsWidth = LsWidth(pageSize)
    // console.log(lsWidth)

    // find key columns
    let keys = tblKeys
    let widthKeys = 0
    if (widths.length > 0) {
        widthKeys = widths.slice(0, keys).reduce((widthKeys, v) => widthKeys + v)
        // console.log(widthKeys)

        let start = keys
        let widthOrig = ((lsWidth / (pdfGridFontWidth)) - widthKeys)
        let width = widthOrig
        // console.log(width)
        let cols = headers[0].length
        for (let i = keys; i < cols; i++) {

            width -= widths[i]
            // console.log(width)
            if (width < 0 || i === (cols - 1)) {
                // check to ensure we have at least 4 columns
                let last = i + 1
                if (i !== (cols - 1)) {
                    if ((cols - i) < 4) {
                        last = cols - 4
                    }
                }
                let tbl = {
                    headers: [],
                    rows: [],
                    widthsPct: []
                }
                // 2d hdrs
                // console.log("Table Part, final width:" + width)
                // console.log(start + " to " + last)
                for (let h = 0; h < headers.length; h++) {
                    let hr = structuredClone([...headers[h].slice(0, keys), ...headers[h].slice(start, last)])
                    tbl.headers.push(hr)
                }
                // 2d rows
                for (let r = 0; r < rows.length; r++) {
                    let row = structuredClone([...rows[r].slice(0, keys), ...rows[r].slice(start, last)])
                    tbl.rows.push(row)
                }
                let totalWidth = 0
                tbl.widths = [...widths.slice(0, keys), ...widths.slice(start, last)]
                totalWidth = tbl.widths.reduce((totalWidth, v) => totalWidth + v)
                if (totalWidth !== 0) {
                    tbl.widthsPct = tbl.widths.map((cw) => (cw * 100 / totalWidth) + "%")
                }
                // console.log(tbl)
                tbls.push(tbl)
                start = last
                width = widthOrig
                // in case we have made this row a bit shorter reduce the width for columns ew push to the next row
                for (let j = start; j < i; j++) {
                    width -= widths[j]
                }
            }
        }
    }

    return tbls
}

const AddComment = (comment) => {
    let content = []


    if (comment !== undefined && comment !== "") {
        let s = "Discussion: " + comment
        content.push({
            margin: [0, 2, 0, 0],

            style: "ruleText",
            text: s,
        })
    }
    return content
}





export const pdfChartGrid = async (clientJson, page, data, avail, headers, pageSize, fontSize) => {
    let content = []
    //console.log(page)
    for (const cur of avail.Currency) {
        if (!page.Currency.includes(cur)) {
            continue
        }
        let pg = structuredClone(page)
        pg.Currency = cur

        for (const client of avail.Clients) {
            if (data.Clients.length === 1) {
                if (client !== 'Personal') {
                    continue
                }
            } else {
                if (!page.Who.includes(client)) {
                    continue
                }
            }
            pg.Who = client


            let clds = Client(pg, data)
            // console.log(data)
            // console.log(pg)
            // console.log(clds)


            if (clds.length === 0) {
                continue
            }
            let cl = clds[0]
            let ds = clds[1]


            // console.log(pg.Name)
            //console.log(cl)
            //console.log(ds)
            // console.log(data)
            // console.log(headers)
            let columns = headers
            let rows = null
            let topRow = null
            if (headers === null) {
                columns = data.ClientData[cl][ds].Headers;
                rows = data.ClientData[cl][ds].Data
                if (data.ClientData[cl][ds].TopRow !== undefined) {
                    topRow = data.ClientData[cl][ds].TopRow
                }
            } else {
                rows = data.ClientData[cl][ds]
            }
            if (rows === null) {
                continue
            }

            // console.log(columns)
            // get the columes that are visible, this still has them in the children pointers etc
            //console.log(page)
            let pdfColumnsV = getVisibleColumns(columns, true, [], page.AdditionalColumns, page.DefaultColumns)
            // console.log(pdfColumnsV)

            // the header rows to export to the table
            let [pdfHeaders, tblKeys] = getHeaderToExport(pdfColumnsV);
            // console.log(pdfHeaders)

            // this only has the field/colId entries 
            let pdfColumns = getColumns(pdfColumnsV)
            // console.log(pdfColumns)
            let pdfRows = getRowsToExport(pdfColumns, pdfHeaders, rows, topRow, page.Aggregate);
            // console.log(pdfRows)
            let [pdfWidths,] = getRowWidths(pdfRows)
            // console.log(pdfWidths)

            let tbls = splitColumns(pdfRows, pdfHeaders, pdfWidths, pageSize, tblKeys)
            // console.log(tbls)

            // console.log(pg.Name + " has " + tblKeys + " keys")
            let cnt = 1
            for (let tbl of tbls) {
                // console.log(tbl)
                let contd = ""
                if (tbls.length !== 1) {
                    contd = "  (page " + cnt + " of " + tbls.length + ")"
                }
                content.push({
                    pageBreak: "before",
                    pageOrientation: 'landscape',
                    columns: [{
                        text: pg.Name + contd,
                        style: "tableTitle",
                    },
                    {
                        text: cl + " : " + ds,
                        alignment: "right",
                        style: "tableTitle",
                    }],
                })




                content.push({
                    layout: createLayout(tbl.headers.length),
                    // alignment: "center",
                    table: {

                        // the number of header rows
                        headerRows: tbl.headers.length,

                        // the width of each column, can be an array of widths
                        // widths: `${100 / pdfColumns.length}%`,
                        widths: [...tbl.widthsPct],
                        //widths: "auto",

                        // all the rows to display, including the header rows
                        body: [...tbl.headers, ...tbl.rows],

                        // Header row is 40px, other rows are 15px
                        heights: (i) => (i < tbl.headers.length ? fontSize + 4 : fontSize),

                    },
                })
                cnt++
            }
            content.push(AddComment(data.Info.Description))
        }
    }
    // console.log(content)
    return content
}



export const getTextRule = (e, ui = false) => {
    let r = {
        Year: "",
        Text: "",
    }

    if (e.TextRule !== undefined) {
        if (e.Editable) {
            let deflt = ""
            if (e.Default) {
                deflt = " (default rule) "
            }
            if (ui) {
                r.Year = e.Year + deflt
            } else {
                r.Text = "\n" + e.Year + deflt + "\n"
            }
        }
        if (ui) {
            r.Text = "   " + e.TextRule
        } else {
            r.Text += "   " + e.TextRule + "\n"
        }
    }
    return r
}





export const pdfRules = async (clientJson, page, data) => {

    let content = []

    let cl = data.Clients[0]
    let rules_0 = RuleTexts(data.ClientData[cl], cl)

    let cl1 = ""
    let rules_1 = ""
    if (data.Clients.length > 1) {
        cl1 = data.Clients[1]
        rules_1 = RuleTexts(data.ClientData[cl1], cl1)

    }



    content.push({
        pageBreak: "before",
        pageOrientation: 'landscape',
        text: "Rules",
        style: "ruleHeading3",
    })
    content.push({
        style: "ruleHeading2",
        columns: [{
            text: cl,
        }, {
            text: cl1,
        }],
    })
    content.push({
        text: "Desired Savings",
        style: "ruleHeading",
    })

    content.push({
        style: "ruleText",
        columns: [{
            text: rules_0.Desired,
        }, {
            text: rules_1.Desired
        }],
    })

    content.push({
        style: "ruleHeading",
        text: "Surplus Savings",
    })

    content.push({
        style: "ruleText",
        columns: [{
            text: rules_0.Surplus,
        }, {
            text: rules_1.Surplus,
        }],
    })

    content.push({
        style: "ruleHeading",
        text: "Additional Income",
    })

    content.push({
        style: "ruleText",
        columns: [{
            text: rules_0.Income,
        }, {
            text: rules_1.Income,
        }]
    })

    return content
}

// const ValueInf = (value) => {
//     let resp = "$" + formatNumber(value) + "  "

//     return resp
// }
// const Spousal = (spp) => {
//     let resp = ""
//     if (spp !== undefined) {
//         resp += ", spousal percentage: " + spp + "%  "
//     }
//     return resp
// }

// const UpToRepeat = (upto, repeat) => {
//     let r = ""
//     if (upto !== undefined && upto !== 0) {
//         r = "Up to age: " + upto + " "
//     }
//     if (repeat !== undefined && repeat > 1) {
//         r += " repeat every " + repeat + "years"
//     }
//     if (r !== "") {
//         r += " "
//     }
//     return r
// }

const StdAccount = (data) => {
    let resp = {
        Text: "",
        Name: "",
        Once: "",
        Array: []
    }
    if (data) {

        let sortdata = data.toSorted((a, b) => ((a.FullName < b.FullName) ? -1 : ((a.FullName === b.FullName) ? (a.Year - b.Year) : 1)))
        //console.log(data)
        //console.log(sortdata)
        for (let i = 0; i < sortdata.length; i++) {
            let ar = {
                Name: "",
                Once: "",
                Text: "",
            }
            let d = sortdata[i]

            if (d.Editable) {
                resp.Text += "\n\t" + d.FullName + "\n"
                if (d.TextOnce !== "") {
                    resp.Text += " " + d.TextOnce + "\n"
                }
                resp.Name = d.FullName
                if (d.TextOnce !== "") {
                    resp.Once = d.TextOnce
                }
                ar.Name = d.FullName
                ar.Once = d.TextOnce
            }
            resp.Text += d.Text + "\n"
            ar.Text = d.Text
            resp.Array.push(ar)
        }
    }
    //console.log(resp)
    return resp
}

const GovAccount = (data) => {
    let resp = {
        Text: "",
        Name: "",
        Once: "",
        Array: []
    }
    if (data !== null) {
        for (let i = 0; i < data.length; i++) {
            let d = data[i]

            let text = "\nCPP\n" + d.Cpp.Text + "\n"
            for (let j = 0; j < Arrayify(d.Cpp.TableText).length; j++) {
                text += "\t" + d.Cpp.TableText[j] + "\n"
            }
            text += "\nOAS\n" + d.Oas.Text + "\n"
            if (d.Gis.Text !== "") {
                text += "\nGIS\n" + d.Gis.Text + "\n"
            }
            text += "\nBenefits\n" + d.Credits.Text + "\n"

            resp.Text += text

            // resp.Name = "CPP, OAS, GIS, Benefits"
            if (d.Cpp.Text !== "") {
                resp.Array.push({ Name: "CPP", Once: "", Text: d.Cpp.Text, TableText: d.Cpp.TableText })
            }
            if (d.Oas.Text !== "") {
                resp.Array.push({ Name: "OAS", Once: "", Text: d.Oas.Text })
            }
            if (d.Gis.Text !== "") {
                resp.Array.push({ Name: "GIS", Once: "", Text: d.Gis.Text })
            }
            if (d.Credits.Text !== "") {
                resp.Array.push({ Name: "Benefits", Once: "", Text: d.Credits.Text })
            }
        }
    }
    // console.log(resp)
    return resp
}

const TextAccount = (a, n, cl) => {
    if (a[n] !== undefined) {
        if (a[n][cl] !== undefined) {
            return a[n][cl].Text
        }
    }
    return ""
}

const AddAccount = (accounts, name) => {
    let content = []
    content.push({
        style: "ruleHeading",
        text: name
    })


    content.push({
        style: "ruleText",
        columns: [{
            text: TextAccount(accounts, name, 0)
        }, {
            text: TextAccount(accounts, name, 1)
        }],
    })
    // console.log(content)
    return content

}


const accountTypePrettyNames = {
    NonRegistered: "Non-Registered",
    DBPension: "Defined Benefit Pension",
    InvestLoan: "Investment Loan",
};

export const AccountTypePrettyNames = (an) => {
    return accountTypePrettyNames[an] ? accountTypePrettyNames[an] : an
}


export const inputTexts = (data, cl) => {
    let accounts = {
        Employment: [],
        Expenses: [],
        NonRegistered: [],
        InvestLoan: [],
        Registered: [],
        Retirement: [],
        Liability: [],
        Property: [],
        Inheritance: [],
        DBPension: [],
        Annuity: [],
        Government: [],
    }
    if (!cl) {
        return accounts
    }
    for (let c = 0; c < cl.length; c++) {
        //console.log(data)
        //console.log(cl)
        let d = data[cl[c]]
        //console.log(d)
        accounts["Employment"][c] = StdAccount(d.Employment)
        accounts["Expenses"][c] = StdAccount(d.Expenses)
        accounts["NonRegistered"][c] = StdAccount(d.NonRegistered)
        accounts["InvestLoan"][c] = StdAccount(d.InvestLoan)
        accounts["Registered"][c] = StdAccount(d.Registered)
        accounts["Retirement"][c] = StdAccount(d.Retirement)
        // this isn't a std Account, but for this purpose it has the same format
        accounts["DBPension"][c] = StdAccount(d.Pension)
        accounts["Annuity"][c] = StdAccount(d.Annuity)

        accounts["Liability"][c] = StdAccount(d.Liability)
        accounts["Property"][c] = StdAccount(d.Property)
        accounts["Inheritance"][c] = StdAccount(d.Inheritance)
        accounts["Government"][c] = GovAccount(d.Government)


        // console.log(accounts)
    }
    return accounts

}

export const pdfInputs = async (clientJson, page, data) => {
    let content = []
    let cl = data.Clients
    // console.log(data)
    // console.log(cl)
    let accounts = {
        Employment: [],
        Expenses: [],
        NonRegistered: [],
        InvestLoan: [],
        Registered: [],
        Retirement: [],
        Liability: [],
        Property: [],
        Inheritance: [],
        DBPension: [],
        Annuity: [],
        Government: [],
    }
    if (!cl) {
        return content
    }
    for (let c = 0; c < cl.length; c++) {
        let d = data.ClientData[cl[c]]
        accounts["Employment"][c] = StdAccount(d.Employment)
        accounts["Expenses"][c] = StdAccount(d.Expenses)
        accounts["NonRegistered"][c] = StdAccount(d.NonRegistered)
        accounts["InvestLoan"][c] = StdAccount(d.InvestLoan)
        accounts["Registered"][c] = StdAccount(d.Registered)
        accounts["Retirement"][c] = StdAccount(d.Retirement)
        // this isn't a std Account, but for this purpose it has the same format
        accounts["DBPension"][c] = StdAccount(d.Pension)
        accounts["Annuity"][c] = StdAccount(d.Annuity)

        accounts["Liability"][c] = StdAccount(d.Liability)
        accounts["Property"][c] = StdAccount(d.Property)
        accounts["Inheritance"][c] = StdAccount(d.Inheritance)
        accounts["Government"][c] = GovAccount(d.Government)


        // console.log(accounts)
    }


    content.push({
        pageBreak: "before",
        pageOrientation: 'landscape',
        style: "ruleHeading3",
        text: "Accounts",
    })


    if (data.PostRunModified) {
        content.push({
            style: "important",
            text: "NOTE:  Input has been modified after this scenario was last executed\n\n"
        })
    }

    content.push({
        style: "ruleHeading2",
        columns: [{
            text: cl[0],
        }, {
            text: (cl.length > 1 ? cl[1] : ""),
        }],
    })

    // console.log(accounts)
    content.push(AddAccount(accounts, "Employment"))
    content.push(AddAccount(accounts, "Expenses"))
    content.push(AddAccount(accounts, "NonRegistered"))
    content.push(AddAccount(accounts, "InvestLoan"))
    content.push(AddAccount(accounts, "Registered"))
    content.push(AddAccount(accounts, "Retirement"))
    content.push(AddAccount(accounts, "DBPension"))
    content.push(AddAccount(accounts, "Annuity"))
    content.push(AddAccount(accounts, "Liability"))
    content.push(AddAccount(accounts, "Property"))
    content.push(AddAccount(accounts, "Inheritance"))
    content.push(AddAccount(accounts, "Government"))




    //accounts.map((k, v) => { content.push(AddAccount(accounts, k)) })


    // console.log(content)
    return content
}


export const RuleTexts = (data, name) => {
    let json = {
        Desired: "",
        DesiredA: [],
        Surplus: "",
        SurplusA: [],
        Income: "",
        IncomeA: [],

    }
    if (name !== "") {
        data.Desired.forEach(e => {
            json.Desired += getTextRule(e).Text
            json.DesiredA.push(getTextRule(e, true))

        });
        data.Surplus.forEach(e => {
            json.Surplus += getTextRule(e).Text
            json.SurplusA.push(getTextRule(e, true))
        });

        data.Income.forEach(e => {
            json.Income += getTextRule(e).Text
            json.IncomeA.push(getTextRule(e, true))
        });
    }
    return json
}

export const scenInputTexts = (data) => {
    let json = {
        Scenario: "",
        ScenarioA: [],
        Dates: "",
        DatesA: [],
        Client: "",
        ClientA: [],
        Spouse: "",
        SpouseA: [],
        Modified: {
            When: ""
        },
        Executed: {
            When: ""
        },
        PostRunModified: false,
        TaxText: "",
        TaxTextA: [],

    }
    // console.log(data)
    Arrayify(data.Text).forEach(e => {
        json.Scenario += e + "\n"
        json.ScenarioA.push(e)
    });
    Arrayify(data.DateText).forEach(e => {
        json.Dates += e + "\n"
        json.DatesA.push(e)
    });
    if (data.person.length > 0 && data.person[0].Text) {
        data.person[0].Text.forEach(e => {
            json.Client += e + "\n"
            json.ClientA.push(e)
        });
    }
    if (data.person.length > 0 && data.person[0].TaxText) {
        data.person[0].TaxText.forEach(e => {
            json.TaxText += e + "\n"
            json.TaxTextA.push(e)
        });
    }
    if (data.person.length > 1 && data.person[1].Text) {
        data.person[1].Text.forEach(e => {
            json.Spouse += e + "\n"
            json.SpouseA.push(e)
        });
    }
    json.Modified = data.Modified
    json.Executed = data.Executed
    console.log(json)

    return json
}



export const pdfScenInputs = async (clientJson, page, data) => {
    let content = []


    let scenInputs = scenInputTexts(data)


    content.push({
        pageBreak: "before",
        pageOrientation: 'landscape',
        style: "ruleHeading3",
        text: "Scenario Inputs",

    })

    content.push({
        margin: [0, 10, 0, 0],

        style: "ruleText",
        text: scenInputs.Scenario,
    })

    content.push({
        style: "ruleHeading2",
        columns: [{
            text: clientJson.name,
        }, {
            text: clientJson.spouseName,
        }],
    })

    content.push({
        margin: [0, 10, 0, 0],

        style: "ruleText",
        columns: [{
            text: scenInputs.Client,
        }, {
            text: scenInputs.Spouse,
        }],
    })



    return content
}
export const pdfTaxInfo = async (clientJson, page, data) => {
    let content = []


    let scenInputs = scenInputTexts(data)


    content.push({
        pageBreak: "before",
        pageOrientation: 'landscape',
        style: "ruleHeading3",
        text: "Tax Information",

    })
    content.push({
        margin: [0, 10, 0, 0],

        style: "ruleText",
        text: scenInputs.TaxText,
    })

    return content
}

const MyOwnFP_Disclaimer = "The Services and Content provided by MyOwnFP  are provided to you on an “as is” basis without warranties from MyOwnFP of any kind, either express or implied. MyOwnFP expressly disclaims all other warranties, express or implied, including without limitation implied warranties of financial accuracy, fitness for a particular purpose, title and non-infringement. MyOwnFP does not represent or warrant that the Serivces or Content are accurate, complete, reliable, current or error-free."


export const pdfDisclaimer = async (clientJson, page, data) => {
    let content = []

    content.push({
        pageBreak: "before",
        pageOrientation: 'portrait',
        style: "ruleHeading3",
        text: "Disclaimer"
    })

    if (page.Commment !== "") {
        content.push({
            margin: [0, 10, 0, 0],
            style: "ruleText",
            text: page.Comment,
        })
    }
    if (page.Commment !== "") {
        content.push({
            margin: [0, 10, 0, 0],
            style: "ruleText",
            text: data.Disclaimer,
        })
    }
    content.push({
        margin: [0, 10, 0, 0],
        style: "ruleText",
        text: MyOwnFP_Disclaimer,
    })

    return content
}


export const pdfSummary = async (clientJson, page, data) => {
    let content = []

    content.push({
        pageBreak: "before",
        pageOrientation: 'portrait',
        style: "ruleHeading3",
        text: "Summary",
    })


    content.push({
        margin: [0, 10, 0, 0],
        style: "ruleText",
        text: page.Comment,
    })
    return content
}

// var imageIndex = 0

const image_b64 = (uuid, imgLayout) => {
    // console.log(uuid)
    // console.log(imgLayout)
    for (let i = 0; i < Arrayify(imgLayout.Pages).length; i++) {
        for (let j = 0; j < Arrayify(imgLayout.Pages[i].Images).length; j++) {
            //console.log(imgLayout.Pages[i].Images[j])
            if (imgLayout.Pages[i].Images[j].Uuid === uuid) {
                if (imgLayout.Pages[i].Images[j].Data_b64 !== "") {
                    return imgLayout.Pages[i].Images[j].Data_b64
                }

            }
        }
    }
    return ""
}


const which_image_b64 = (page, index, imgLayout) => {
    let img_b64 = ""
    let imageKey = "text"
    if (Arrayify(page.ImageContents).length > 0) {
        if (page.ImageContents[index] !== "") {
            img_b64 = "data:image/png;base64, " + page.ImageContents[index]
            imageKey = "image"
        }
    } else {
        if (Arrayify(page.Images).length > 0) {
            img_b64 = image_b64(page.Images[index].Uuid, imgLayout)
            if (img_b64 !== "") {
                img_b64 = "data:image/png;base64, " + img_b64
                imageKey = "image"
            }
        }
    }
    return [imageKey, img_b64]
}

export const pdfCover = async (clientJson, page, data, imgLayout, pageSize, preparedBy, executedDate) => {
    let content = []
    let images = {}

    content.push({
        pageBreak: "before",
        pageOrientation: 'portrait',
        style: "ruleHeading3",
        table: {
            widths: '*',
            paddingTop: 30,
            body: [
                ["Prepared for: " + clientJson.name + (clientJson.spouseName ? " & " + clientJson.spouseName : "")]
            ]
        },
    })

    // ++imageIndex
    // let urlId = "CoverUrl" + imageIndex

    var imageWidth = 400
    var imageHeight = 600
    var sectionHeight = PHeight(pageSize) - 100
    var topMargin = (sectionHeight - imageHeight) / 2;

    let [imageKey, imageB64] = which_image_b64(page, 0, imgLayout)

    // console.log(img_b64)

    content.push({
        margin: [0, 10, 0, 10],

        style: "ruleText3",
        columns: [{
            margin: [0, sectionHeight / 2, 0, sectionHeight / 2],
            style: "ChapterTitle",
            text: "Financial Plan\n" + clientJson.Scenario.label,
        }, {
            //image: "data:image/png;base64, " + page.ImageContents[0],
            // image if set now, URL if from server
            //image: (Arrayify(page.ImageContents).length > 0 && page.ImageContents[0] !== "") ? "data:image/png;base64, " + page.ImageContents[0] : urlId,
            [imageKey]: imageB64,
            alignment: "center",
            width: imageWidth,
            height: imageHeight,
            margin: [0, topMargin, 0, topMargin]
        }],
    })
    // if (Arrayify(page.ImageContents).length === 0 || page.ImageContents[0] === "") {
    //     console.log(page.Images)
    //     if (Arrayify(page.Images).length > 0 && page.Images[0].Url !== "") {
    //         images[urlId] = page.Images[0].Url
    //     }
    //     console.log(images)
    // }

    content.push({
        style: "ruleHeading3",
        table: {
            widths: '*',
            body: [
                ["Prepared by: " + preparedBy, { text: 'Date: ' + executedDate, alignment: 'right' }]
            ]
        },
    })
    return [content, images]
}


export const pdfChapter = async (clientJson, page, data, imgLayout, pageSize) => {
    let content = []
    var imageWidth = 400
    var imageHeight = 600
    var sectionHeight = PHeight(pageSize)
    var topMargin = (sectionHeight - imageHeight) / 2;

    let [imageKey, imageB64] = which_image_b64(page, 0, imgLayout)

    // console.log(page)
    content.push({
        pageBreak: "before",
        pageOrientation: 'portrait',
        margin: [0, 10, 0, 10],

        style: "ruleText3",
        columns: [{
            margin: [0, sectionHeight / 2, 0, 0],
            style: "ChapterTitle",
            text: page.Comment,

        }, {
            [imageKey]: imageB64,
            alignment: "center",
            width: imageWidth,
            height: imageHeight,
            margin: [0, topMargin, 0, topMargin]
        }],
    })

    return content
}


